export default __webpack_public_path__ + "static/reward-2c6a69c4ae7b0f69ac651171c4d3f43c.png";